function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext } from "react";
import { ComboBox, SelectSkeleton } from "@carbon/react";
import propertyUtils from "../../../utils/property-util";
import { format } from "../../../utils/locales";
import { i18nContext, servicesContext } from "../table-context";
var itemToString = function itemToString(item) {
  return item ? item.text : "";
};
function IntegrationPropertySelect(_ref) {
  var isLoading = _ref.isLoading,
    property = _ref.property,
    updateProperty = _ref.updateProperty;
  var i18n = useContext(i18nContext);
  var toolchainServices = useContext(servicesContext);
  var findSelectedItem = function findSelectedItem(itemProperty) {
    var selected = null;
    if (itemProperty.value) {
      var selectedService = toolchainServices.find(function (item) {
        var _item$toolchain_bindi;
        return item.instance_id === itemProperty.value || ((_item$toolchain_bindi = item.toolchain_binding) === null || _item$toolchain_bindi === void 0 ? void 0 : _item$toolchain_bindi.name) === itemProperty.value;
      });
      selected = selectedService ? {
        id: selectedService.instance_id,
        text: propertyUtils.getIntegrationDisplayName(selectedService)
      } : {
        id: itemProperty.value,
        text: format(i18n.messages.integrationRemoved, [itemProperty.value])
      };
    }
    return selected;
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(SelectSkeleton, {
      className: "cds--form-item ocr--integration-select-skeleton",
      hideLabel: true
    });
  }
  var items = toolchainServices ? toolchainServices.map(function (service) {
    return {
      id: service.instance_id,
      text: propertyUtils.getIntegrationDisplayName(service)
    };
  }).sort(function (a, b) {
    return a.text.localeCompare(b.text);
  }) : [];
  var selectedItem = null;
  if (property.value) {
    selectedItem = findSelectedItem(property);
  }
  var handleChange = function handleChange(event) {
    var _event$selectedItem;
    var value = ((_event$selectedItem = event.selectedItem) === null || _event$selectedItem === void 0 ? void 0 : _event$selectedItem.id) || "";
    updateProperty(_objectSpread(_objectSpread({}, property), {}, {
      value: value
    }));
  };
  return /*#__PURE__*/React.createElement(ComboBox, {
    className: "ocr--property-select-dropdown",
    direction: "bottom",
    id: "ocr--property-panel-integration-select",
    items: items,
    itemToString: itemToString,
    onChange: handleChange,
    placeholder: i18n.messages.integrationSelect,
    selectedItem: selectedItem,
    titleText: i18n.messages.integration,
    translateWithId: function translateWithId(menuId) {
      var translations = {
        "close.menu": i18n.messages.menuClose,
        "open.menu": i18n.messages.menuOpen
      };
      return translations[menuId];
    }
  });
}
export default IntegrationPropertySelect;